<form
  [formGroup]="entryForm"
  (ngSubmit)="saveEntry()"
  autocomplete="on"
  class="container-grid form-parent"
  [ngStyle]="containerStyles"
>
  <div class="grid-first">
    <label for="tipo-entrada-opcion" class="form-label">Tipo de entrada*</label>
    <select
      id="tipo-entrada-opcion"
      class="form-control"
      [formControl]="tipoEntrada"
      *ngIf="movimiento == 'crear'"
    >
      <option *ngFor="let item of entriesType" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
    <select
      id="tipo-entrada-opcion"
      class="form-control"
      formControlName="entry_type_id"
      *ngIf="movimiento !== 'crear'"
    >
      <option *ngFor="let item of entriesType" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
  </div>
  <div *ngIf="movimiento !== 'crear'">
    <label for="noOperacion" class="form-label">No. de operación*</label>
    <input
      type="number"
      id="noOperacion"
      class="form-control"
      [value]="id"
      disabled
    />
  </div>
  <div>
    <label for="clave-recinto" class="form-label">Clave del recinto*</label>
    <input
      type="number"
      id="clave-recinto"
      class="form-control"
      formControlName="precinct_key"
    />
  </div>
  <div>
    <label for="tipo-transporte" class="form-label">Tipo de transporte*</label>
    <select
      id="tipo-transporte"
      class="form-control"
      (change)="changeTransport()"
      formControlName="transport_type_id"
    >
      <option value="">-- Seleccione un transporte --</option>
      <option *ngFor="let item of tipoTransporte" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('transport_type_id')"
    >
      Seleccione un tipo de transporte
    </span>
  </div>
  <ng-container *ngIf="entryForm.get('transport_type_id')?.value == '2'">
    <div class="grid-first">
      <label for="shipNumber" class="form-label">No. de barco*</label>
      <input
        type="text"
        id="shipNumber"
        class="form-control"
        formControlName="ship_number"
        maxlength="9"
        appBlockLetters
      />
      <span class="form-text text-danger" *ngIf="campoEsValido('ship_number')">
        Ingrese el número del barco
      </span>
    </div>

    <div>
      <label for="shipName" class="form-label">Nombre del barco*</label>
      <input
        type="text"
        maxlength="40"
        id="shipName"
        class="form-control"
        formControlName="ship_name"
      >
      <span class="form-text text-danger" *ngIf="campoEsValido('ship_name')">
        Ingresa el nombre del barco
      </span>
    </div>

    <div>
      <label for="fechaRecinto" class="form-label">Fecha de ingreso al recinto fiscalizado*</label>
      <input
        type="date"
        id="fechaRecinto"
        class="form-control"
        formControlName="admission_date"
      />
      <span
        class="form-text text-danger"
        *ngIf="campoEsValido('admission_date')"
      >
        Ingrese la fecha
      </span>
    </div>

    <div class="grid-first">
      <label for="total_tonnage" class="form-label">Tonelaje*</label>
      <input
        type="text"
        id="total_tonnage"
        class="form-control"
        formControlName="total_weight"
        maxlength="15"
        appBlockLetters
      />
      <span class="form-text text-danger" *ngIf="campoEsValido('total_weight')">
        Ingrese el tonelaje válido
      </span>
    </div>

    <div>
      <label for="piezas" class="form-label"
        >Piezas*</label
      >
      <input
        type="text"
        id="piezas"
        class="form-control"
        appOnlyNumbers
        [maxDigits]="10"
        formControlName="total_pieces"
      />
      <span class="form-text text-danger" *ngIf="campoEsValido('total_pieces')">
        Ingrese las piezas válidas
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="entryForm.get('transport_type_id')?.value != '2'">
    <div *ngIf="entryForm.get('transport_type_id')?.value == '1'">
      <label for="remolque" class="form-label">Remolque*</label>
      <select
        id="remolque"
        class="form-control"
        formControlName="trailer_id"
      >
        <option value="">-- Seleccione un tipo de remolque --</option>
        <option *ngFor="let item of tipoUnidad" [value]="item.id">
          {{ item.description }}
        </option>
      </select>
      <span class="form-text text-danger" *ngIf="campoEsValido('trailer_id')">
        Seleccione remolque
      </span>
    </div>
    <div *ngIf="entryForm.get('transport_type_id')?.value">
      <label for="origin_ticket" class="form-label">Tipo de báscula*</label>
      <select
        id="origin_ticket"
        class="form-control"
        (change)="changeOriginTicket()"
        formControlName="original_scale_id"
      >
        <option value="">-- Seleccione báscula  --</option>
        <option *ngFor="let item of originsTicket" [value]="item.id">
          {{ item.description }}
        </option>
      </select>
      <span class="form-text text-danger" *ngIf="campoEsValido('original_scale_id')">
        Seleccione báscula
      </span>
    </div>
    <div class="grid-first" *ngIf="entryForm.get('original_scale_id')?.value == '2' && entryForm.get('transport_type_id')?.value == '3'">
      <label for="railway_group" class="form-label">Grupo de ferrocarril*</label>
      <input
        type="text"
        id="railway_group"
        class="form-control"
        formControlName="railway_group"
        maxlength="20"
        appBlockLetters
        *ngIf="!loaderRailwayGroup"
      />
      <div class="loader-cotainer" *ngIf="loaderRailwayGroup">
        <app-loader2></app-loader2>
      </div>
      <span class="form-text text-danger" *ngIf="campoEsValido('railway_group')">
        Ingrese el grupo de ferrocarril
      </span>
    </div>
    <div *ngIf="entryForm.get('transport_type_id')?.value == '1'">
      <label for="placasFerrocarril" class="form-label">Placa de transporte*</label>
      <input
        type="text"
        id="placasFerrocarril"
        class="form-control"
        maxlength="20"
        formControlName="tractor_plates"
      />
      <span class="form-text text-danger" *ngIf="campoEsValido('tractor_plates')">
        Ingrese la placa de transporte
      </span>
    </div>
    <div class="subtitle table-header">
      <h2 class="title">Información del transporte <sup class="title__sub" *ngIf="transportList.length">{{transportList.length}}</sup></h2>
      <button type="button" class="add-button" (click)="createTransport()" *ngIf="movimiento !== 'detalle'">
        Agregar
      </button>
    </div>
    <app-table
      class="subtitle"
      [table_config]="table_config"
      [array]="transportList"
      [loader]="loader"
      (onDetalleEntryExport)="downloadTicket($event)"
      (onEliminarAbandono)="mostrarSalida($event, 'detalle')"
      (onActualizarAbandono)="mostrarSalida($event, 'actualizar')"
      (onEliminarEntryExport)="confirm($event)"
    ></app-table>
  </ng-container>
  <app-overlay
    *ngIf="transportDelete"
    [buttons]="true"
    mensaje="¿Estás seguro de eliminar el registro?"
    (onDeleteLote)="deleteTransport($event)"
  ></app-overlay>
  <app-amounts-by-input-locations
    class="subtitle"
    [movimiento]="movimiento"
    [locations]="locations"
    [entryTonnage]="entryTonnage"
    [entryPieces]="entryPieces"
    [entryDetail]="entryDetalle"
  ></app-amounts-by-input-locations>
  <ng-container *ngIf="entryForm.get('transport_type_id')?.value == '2'">
    <div>
      <label for="nombreChecador" class="form-label">Nombre del checador*</label>
      <input
        type="text"
        id="nombreChecador"
        class="form-control"
        formControlName="checker_name"
        maxlength="150"
      />
      <span
        class="form-text text-danger"
        *ngIf="campoEsValido('checker_name')"
      >
        Ingrese el nombre del checador
      </span>
    </div>

    <div>
      <label for="noBL" class="form-label">No. de BL*</label>
      <input
        type="text"
        id="noBL"
        class="form-control"
        formControlName="bl_number"
        maxlength="20"
      />
      <span
        class="form-text text-danger"
        *ngIf="campoEsValido('bl_number')"
      >
        Ingrese el BL
      </span>
    </div>

    <div>
      <label for="customs_agent" class="form-label">Agencia naviera*</label>
      <input
        type="text"
        id="customs_agent"
        class="form-control"
        formControlName="customs_agent"
        maxlength="150"
      />
      <span
        class="form-text text-danger"
        *ngIf="campoEsValido('customs_agent')"
      >
        Ingrese la agencia naviera
      </span>
    </div>

    <div class="grid-first">
      <label for="load_conditions" class="form-label">Condiciones de carga</label>
      <input
        type="text"
        id="load_conditions"
        class="form-control"
        formControlName="load_conditions"
        maxlength="150"
      />
    </div>

    <div class="grid-span2">
      <label for="observations" class="form-label">Observaciones</label>
      <input
        type="text"
        id="observations"
        class="form-control"
        formControlName="observations"
        maxlength="300"
      />
    </div>
  </ng-container>
  <ng-container *ngIf="entryForm.get('transport_type_id')?.value != '2'">
    <div>
      <label for="linea-transportista" class="form-label"
        >Línea transportista*</label
      >
      <i class="bi bi-search search" (click)="togleOverlayTransportLine()"></i>
      <select id="linea-transportista" class="form-control" formControlName="transport_line">
        <option value="">-- Seleccionar --</option>
        <option *ngFor="let element of listTransportLine" [value]="element.id">
          {{ element.description }}
        </option>
      </select>
      <span class="form-text text-danger" *ngIf="campoEsValido('transport_line')">
        Seleccione la línea transportista
      </span>
    </div>
    <div *ngIf="entryForm.get('transport_type_id')?.value == '1'">
      <label for="nombre-operador" class="form-label">Operador*</label>
      <input
        type="text"
        id="nombre-operador"
        class="form-control"
        maxlength="50"
        formControlName="operator_name"
      />
      <span class="form-text text-danger" *ngIf="campoEsValido('operator_name')">
        Ingrese el nombre del operador
      </span>
    </div>
    <div>
      <label for="nombreChecador" class="form-label">Nombre del checador*</label>
      <input
        type="text"
        id="nombreChecador"
        class="form-control"
        formControlName="checker_name"
        maxlength="150"
      />
      <span
        class="form-text text-danger"
        *ngIf="campoEsValido('checker_name')"
      >
        Ingrese el nombre del checador
      </span>
    </div>
    <div class="grid-first">
      <label for="fechaRecinto" class="form-label">Fecha de ingreso al recinto fiscalizado*</label>
      <input
        type="date"
        id="fechaRecinto"
        class="form-control"
        formControlName="admission_date"
      />
      <span
        class="form-text text-danger"
        *ngIf="campoEsValido('admission_date')"
      >
        Ingrese la fecha
      </span>
    </div>
    <div>
      <label *ngIf="movimiento != 'detalle'" for="ticket-bascula" class="form-label">Documento de tickets</label>
      <p *ngIf="movimiento == 'detalle'" class="form-label">Documento de tickets</p>
      <input
        type="file"
        accept=".pdf"
        id="ticket-bascula"
        class="form-control mb-2"
        (change)="fileInput($event, 'cabotage_entrance_ticket')"
        *ngIf="movimiento == 'crear' || movimiento == 'actualizar'"
      />
      <a
        *ngIf="movimiento !== 'crear' && archivos.ticketBascula"
        [href]="archivos.ticketBascula"
        target="_blank"
        class="form-control fileUrl"
        >Descargar Archivo</a
      >
      <p class="form-control fileUrl" *ngIf="movimiento == 'detalle' && !archivos.ticketBascula">Sin archivo</p>
      <span
        class="form-text text-danger"
        *ngIf="campoEsValido('cabotage_entrance_ticket')"
      >
        {{ mensajeError }}
      </span>
      <span
        class="form-text text-danger"
        *ngIf="maxSize && !campoEsValido('cabotage_entrance_ticket')"
      >
        {{ mensajeError }}
      </span>
    </div>
  </ng-container>
  <div class="grid-all container-button">
    <button
      type="button"
      class="btn-lote me-5"
      (click)="regresar()"
      *ngIf="movimiento !== 'crear'"
    >
      Regresar
    </button>
    <button
      type="submit"
      class="btn-lote ms-5"
      *ngIf="movimiento !== 'detalle'"
    >
      Guardar
    </button>
  </div>
</form>
<div class="overlay" *ngIf="transportLineOverlay">
  <div class="overlay__content" style="padding-bottom: 30px;">
    <h2 class="title">
      <span (click)="togleOverlayTransportLine()">
        <app-arrow-back></app-arrow-back>
      </span>
      Línea transportista
    </h2>
    <div class="container-grid" style="margin-bottom: 24px;">
      <div>
        <label for="search-transport-Line" class="form-label">Buscar</label>
        <input
          class="form-control"
          type="text"
          id="search-transport-Line"
          [formControl]="transportLine"
        >
      </div>
    </div>
    <ul class="list-group" *ngIf="!loaderTransportLine">
      <li class="list-group-item" *ngFor="let item of listTransportLineFilter">
        <input
          type="radio"
          class="form-check-input me-1"
          name="listGroupRadio"
          [id]="'transport_line' + item.id"
          [value]="item.id"
          [formControl]="formTransportLine"
        >
        <label
          class="form-check-label stretched-link"
          [for]="'transport_line' + item.id"
        >
          {{ item.description }}
        </label>
      </li>
    </ul>
    <app-loader class="loader" *ngIf="loaderTransportLine"></app-loader>
  </div>
</div>
<div class="formCreateTransport" *ngIf="overlayTransport">
  <div class="detalle-salida">
    <div class="table-header">
      <h2 class="title">
        <span (click)="showCreateTransport()">
          <app-arrow-back></app-arrow-back>
        </span>
        Registro de furgon/remolque
      </h2>
    </div>
    <form
      class="formTransport"
      autocomplete="on"
      [formGroup]="transportForm"
      (ngSubmit)="confirmCreateForm()"
    >
      <div>
        <label for="noFolioTicket" class="form-label">Folio de ticket</label>
        <i class="bi bi-camera" (click)="togleReadQR('camera')"></i>
        <i class="bi bi-qr-code-scan" (click)="togleReadQR('scanner')"></i>
        <input
          type="text"
          id="noFolioTicket"
          class="form-control"
          maxlength="20"
          formControlName="no_ticket"
          *ngIf="!loaderTicket"
        />
        <div class="loader-cotainer" *ngIf="loaderTicket">
          <app-loader2></app-loader2>
        </div>
        <span class="form-text text-danger" *ngIf="isValidTransport('no_ticket')">
          Ingrese el número de folio ticket
        </span>
        <span class="form-text" *ngIf="isValidModule">
          {{ messageTicket }}
        </span>
      </div>
      <div>
        <label for="peso-origen" class="form-label">Peso origen*</label>
        <input
          type="text"
          id="peso-origen"
          class="form-control"
          formControlName="origin_weight"
          maxlength="15"
			    appBlockLetters
        />
        <span class="form-text text-danger" *ngIf="isValidTransport('origin_weight')">
          Ingrese el peso origen válido
        </span>
      </div>
      <div>
        <label for="peso-bruto" class="form-label">Peso bruto*</label>
        <input
          type="text"
          id="peso-bruto"
          class="form-control"
          (change)="weightTransportChange()"
          formControlName="gross_weight"
          maxlength="15"
			    appBlockLetters
        />
        <span class="form-text text-danger" *ngIf="isValidTransport('gross_weight')">
          Ingrese el peso bruto válido
        </span>
      </div>
      <div>
        <label for="peso-tara" class="form-label">Peso tara*</label>
        <input
          type="text"
          id="peso-tara"
          class="form-control"
          (change)="weightTransportChange()"
          formControlName="tare_weight"
          maxlength="15"
			    appBlockLetters
        />
        <span class="form-text text-danger" *ngIf="transportForm.get('tare_weight')?.hasError('required') && transportForm.get('tare_weight')?.touched">
          Ingrese el peso tara válido
        </span>
        <span class="form-text text-danger" *ngIf="transportForm.get('tare_weight')?.hasError('pattern')">
          Ingrese el peso tara válido
        </span>
      </div>
      <div>
        <label for="peso-neto" class="form-label">Peso neto*</label>
        <input
          type="text"
          id="peso-neto"
          class="form-control"
          [value]="net_weight | number : '1.3-3'"
          disabled
        />
      </div>
      <div>
        <label for="piezas" class="form-label"
          >Piezas*</label
        >
        <input
          type="text"
          id="piezas"
          class="form-control"
          appOnlyNumbers
          [maxDigits]="10"
          formControlName="quantity_pieces"
        />
        <span class="form-text text-danger" *ngIf="isValidTransport('quantity_pieces')">
          Ingrese las piezas válidas
        </span>
      </div>
      <div>
        <label for="placas" class="form-label">Placas/No. de Furgón*</label>
        <input
          type="text"
          id="placas"
          class="form-control"
          maxlength="20"
          formControlName="plate"
        />
        <span class="form-text text-danger" *ngIf="isValidTransport('plate')">
          Ingrese las placas/no. de furgón
        </span>
      </div>
      <div>
        <label for="planchon" class="form-label">Planchón</label>
        <input
          type="text"
          id="planchon"
          class="form-control"
          formControlName="no_slab"
          maxlength="20"
        />
        <span class="form-text text-danger" *ngIf="isValidTransport('no_slab')">
          Ingrese el planchón
        </span>
      </div>
      <div>
        <label for="colada" class="form-label">Colada</label>
        <input
          type="text"
          id="colada"
          class="form-control"
          formControlName="no_cast"
          maxlength="20"
        />
        <span class="form-text text-danger" *ngIf="isValidTransport('no_cast')">
          Ingrese la colada
        </span>
      </div>
      <div class="grid-all container-button">
        <button type="button" class="btn-lote" (click)="showCreateTransport()">
          Cancelar
        </button>
        <button type="submit" class="btn-lote ms-5" *ngIf="updateTransport || addTransport">Guardar</button>
      </div>
    </form>
  </div>
</div>
<div class="formCreateTransport" *ngIf="overlayScanner">
  <div class="detalle-salida overlay-scanner overlayScanner">
      <h2 class="title">
        <span>
          <app-arrow-back (click)="togleReadQR('close')"></app-arrow-back>
        </span>
        Lectura de boleta de báscula
      </h2>

      <div class="container-gun-scanner" *ngIf="gunScannerEnabled">
        <div class="mb-3">
          <label for="gunScanner" class="form-label">Scanner</label>
          <textarea
            class="form-control form-control-textarea"
            [formControl]="scannerTextArea"
            autofocus="true"
            id="gunScanner"
            rows="3"
            (keyup.enter)="onEnterPressed()"
          ></textarea>
        </div>
        <button type="button" class="btn-lote mb-3" (click)="onEnterPressed()">Guardar</button>
      </div>

      <select
        class="form-control"
        [formControl]="cameraSelected"
        style="margin-bottom: 8px;"
        (change)="changeCamera()"
        *ngIf="scannerEnabled"
      >
        <option *ngFor="let camera of camerasList" [value]="camera.deviceId">
          {{ camera.label }}
        </option>
      </select>

      <div class="container-scanner">
        <zxing-scanner
          *ngIf="scannerEnabled"
          [scannerEnabled]="scannerEnabled"
          [autofocusEnabled]="autofocusEnabled"
          [device]="selectedDevice"
          (camerasFound)="onCamerasFound($event)"
          (camerasNotFound)="onCamerasNotFound($event)"
          (scanSuccess)="onCodeResult($event)"
        ></zxing-scanner>
        <div *ngIf="camerasList.length === 0 && !gunScannerEnabled && !scannerEnabled" class="container__notfound">
          <i class="bi bi-camera-video-off"></i>
          <p>La cámara no está disponible</p>
        </div>
      </div>
  </div>
</div>
<app-overlay
  *ngIf="confirmCreate"
  mensaje="¿Estas seguro de realizar esta operacion?"
  [buttons]="true"
  (onDeleteLote)="saveTransport($event)"
></app-overlay>
<app-overlay
  *ngIf="overlay"
  [icono]="iconoOverlay"
  [mensaje]="mensajeOverlay"
  [buttons]="buttons"
  (onDeleteLote)="deleteAllTransport($event)"
></app-overlay>
<app-overlay
  *ngIf="loading"
></app-overlay>
